<mat-toolbar class="content-header">
    <span class="page-title">
        {{'workflows.title' | translate}} (Base de donnée général)
    </span>

    <mat-select class="select" [(ngModel)]="selectedFlow" (selectionChange)="changeUrlWorkflows($event)">
        <mat-option *ngFor="let flow of flows" [value]="flow">{{ flow.name }}</mat-option>
      </mat-select>    
</mat-toolbar>

<div class="workflows-container">
    <iframe [src]="flowUrl | safe" height="100%" width="100%"></iframe>
</div>